import React from 'react';
import { Recipe } from '../../../models/Recipe';
import { CustomerRecipe } from '../../../models/CustomerRecipe';
import { ProductRecipeLinkingRequest } from '../../../models/ProductRecipeLinkingRequest';
import { CardLinksRecipeByProduct } from '../../ModalRecipesV2/CardLinksRecipeByProduct/CardLinksRecipeByProduct';
import { Alert } from 'react-bootstrap';
import { RecipeCard } from '../RecipeCard/RecipeCard';
import { CustomerRecipeCard } from '../CustomerRecipeCard/CustomerRecipeCard';

interface RecipeListProps {
  orderRecipes?: Recipe[];
  customerRecipes?: CustomerRecipe[];
  linkingRequests?: ProductRecipeLinkingRequest[];
  deleteLinking?: (linking: ProductRecipeLinkingRequest) => void;
  deleteRecipe?: (recipdId: number) => void;
}

const RecipeList: React.FC<RecipeListProps> = ({
  orderRecipes,
  customerRecipes,
  linkingRequests,
  deleteLinking,
  deleteRecipe
}) => {

  const numberOfRecipes = (orderRecipes?.length||0) + (linkingRequests?.length||0);
  const orderHasAnyRecipe = numberOfRecipes > 0;

  if (!orderHasAnyRecipe) {
    return <Alert variant='warning'>
            Sem receita.
           </Alert>;
  }

  return (
    <>
      {orderRecipes?.map(recipe => {
        return (
          <RecipeCard
            key={`recipe-${recipe.id}`}
            recipe={recipe}
            deleteRecipe={deleteRecipe ? (() => deleteRecipe(recipe.id)) : undefined}
          />
        )
      })}
      {linkingRequests?.map(link => {
        const customerRecipe = customerRecipes?.find(cr => cr.id == link.customerRecipeId);
        if (!customerRecipe) return null;
        return (
          <CardLinksRecipeByProduct
            key={`linking-requests-${link.id}-customer-recipe-${link.customerRecipeId}`}
            linkingRequests={[link]}
            deleteLinking={deleteLinking ? (linking) => deleteLinking(linking) : undefined}
          >
            <CustomerRecipeCard
              recipe={customerRecipe}
            />
          </CardLinksRecipeByProduct>
        )
      })}
    </>
  );
}

export { RecipeList };